"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thirdPartyErrorFilterIntegration = void 0;

var _integration = require("../integration.js");

var _metadata = require("../metadata.js");

var _envelope = require("../utils-hoist/envelope.js");

var _stacktrace = require("../utils-hoist/stacktrace.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This integration allows you to filter out, or tag error events that do not come from user code marked with a bundle key via the Sentry bundler plugins.
 */
const thirdPartyErrorFilterIntegration = exports.thirdPartyErrorFilterIntegration = (0, _integration.defineIntegration)(options => {
  return {
    name: 'ThirdPartyErrorsFilter',

    setup(client) {
      // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
      // TODO(lforst): Move this cleanup logic into a more central place in the SDK.
      client.on('beforeEnvelope', envelope => {
        (0, _envelope.forEachEnvelopeItem)(envelope, (item, type) => {
          if (type === 'event') {
            const event = Array.isArray(item) ? item[1] : undefined;

            if (event) {
              (0, _metadata.stripMetadataFromStackFrames)(event);
              item[1] = event;
            }
          }
        });
      });
      client.on('applyFrameMetadata', event => {
        // Only apply stack frame metadata to error events
        if (event.type) {
          return;
        }

        const stackParser = client.getOptions().stackParser;
        (0, _metadata.addMetadataToStackFrames)(stackParser, event);
      });
    },

    processEvent(event) {
      const frameKeys = getBundleKeysForAllFramesWithFilenames(event);

      if (frameKeys) {
        const arrayMethod = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'apply-tag-if-contains-third-party-frames' ? 'some' : 'every';
        const behaviourApplies = frameKeys[arrayMethod](keys => !keys.some(key => options.filterKeys.includes(key)));

        if (behaviourApplies) {
          const shouldDrop = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'drop-error-if-exclusively-contains-third-party-frames';

          if (shouldDrop) {
            return null;
          } else {
            event.tags = _objectSpread(_objectSpread({}, event.tags), {}, {
              third_party_code: true
            });
          }
        }
      }

      return event;
    }

  };
});

function getBundleKeysForAllFramesWithFilenames(event) {
  const frames = (0, _stacktrace.getFramesFromEvent)(event);

  if (!frames) {
    return undefined;
  }

  return frames // Exclude frames without a filename since these are likely native code or built-ins
  .filter(frame => !!frame.filename).map(frame => {
    if (frame.module_metadata) {
      return Object.keys(frame.module_metadata).filter(key => key.startsWith(BUNDLER_PLUGIN_APP_KEY_PREFIX)).map(key => key.slice(BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    }

    return [];
  });
}

const BUNDLER_PLUGIN_APP_KEY_PREFIX = '_sentryBundlerPluginAppKey:';